export const MODAL_DIALOG__TEMPLATE_PREVIEW = 'MODAL_DIALOG__TEMPLATE_PREVIEW';
